<template>
    <b-card no-body>
        <b-modal id="assign" title="Atama" no-close-on-esc no-close-on-backdrop>
            <user-of-netsis-kasa-assign v-model="model"/>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="assign" text="Ata"></v-executer></template>
        </b-modal>

        <!-- <b-modal id="collar-status-update" title="Yaka" no-close-on-esc no-close-on-backdrop>
            <user-of-netsis-kasa-collar-status-update v-model="collarStatusData"/>
            <template #modal-footer><v-executer :loading="updating" :action="updateCollarStatus" text="Güncelle"></v-executer></template>
        </b-modal> -->

        <v-table    ref="table"
                    :add-callback="createNew"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    search
                    :items-provider="provider"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisOperationsApi from '@/api/netsis-operations'
import UserOfNetsisKasaAssign from './components/UserOfNetsisKasaAssign.vue';
import UserOfNetsisKasaCollarStatusUpdate from './components/UserOfNetsisKasaCollarStatusUpdate.vue';

export default {
    components:{
        BCard,
        UserOfNetsisKasaAssign,
        UserOfNetsisKasaCollarStatusUpdate
    },
    data(){
        return{
            model:{
                Id:null,
                UserId: null,
                KasaKodlari: []
            },
            fields:[
                {name:'Kullanıcı',key:'FullName',thClass:'w-34'},
                {name:'Kasa',key:'KasaAdi',thClass:'w-33 text-nowrap'},
                {name:'Kasa Kodu',key:'KasaKodu',thClass:'w-33 text-nowrap'},
            ],
            buttons:[
                { text:"Atamayı Kaldır",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                // { text:"Yaka",key:"collarstatus",icon:"ShieldIcon",variant:"info",action:this.showCollarStatus },
            ],
            editing:false,
            loading:false,
            collarStatusData:{
                UserOfNetsisKasaId:null,
                CollarStatusIds:[]
            },
            updating:false,
        }
    },
    methods:{
        provider(data){
            return NetsisOperationsApi.UserOfNetsisKasa.Table(data)
        },
        clearForm(){
            this.editing = false
            this.model.Id = null
            this.model.UserId = null
            this.model.KasaKodlari = []
        },
        createNew(){
            this.clearForm()
            this.$showModal('assign')
        },
        assign(){
            this.loading = true
            NetsisOperationsApi.UserOfNetsisKasa.Assign(this.model).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('assign')
                }
                this.loading = false
                this.$result(res)
            }).catch(err => {
                this.loading = false
                this.$result(null,errr)
            })
        },
        showCollarStatus(d){
            this.collarStatusData.UserOfNetsisKasaId = null
            this.collarStatusData.CollarStatusIds = []
            this.collarStatusData.UserOfNetsisKasaId = d.Id
            this.collarStatusData.CollarStatusIds = (d.AuthorizedCollarStatuses || []).map(i => i.CollarStatusId)
            this.$showModal('collar-status-update')
        },
        delete(item){
            this.$confirm('Atamayı kaldırmak istediğinize emin misiniz?',`Bu işlem ${item.Fullname} isimi kullanıcının ${item.KasaAdi} (${item.KasaKodu}) atamasını kaldıracaktır ve geri alınamaz.`).then(result=>{
                if(result){
                    NetsisOperationsApi.UserOfNetsisKasa.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        updateCollarStatus(){
            this.updating = true
            NetsisOperationsApi.UserOfNetsisKasa.CollarStatusAuthorize(this.collarStatusData).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('collar-status-update')
                }
                this.$result(res)
                this.updating = false
            }).catch(err => {
                this.updating = false
                this.$result(null,err)
            })
        }
    }
}
</script>